import { AccountsStoreAll } from './AccountsStoreAll';
import { AccountsStoreOrganization } from './AccountsStoreOrganization';
import { AccountStore } from './AccountStore';

export default {
    accountsStoreAll: new AccountsStoreAll(),
    accountStore: new AccountStore(),
    accountsStoreOrganization: new AccountsStoreOrganization()
};
